/**
 * Enum для типов фильтров в различных разделах ЛК.
 */
export enum FilterSection {
    /** Клиенты - CompaniesTable */
    Clients = 'clients',
    /** Водители - DriversTable */
    Drivers = 'drivers',
    /** Медицинские работники - MedicsTable */
    Medics = 'medics',
    /** Диспетчеры - DispatchersTable */
    Dispatchers = 'dispatchers',
    /** Терминалы - TerminalsTable */
    Terminals = 'terminals',
    /** Новые медосмотры - NewMedicalCheckupsTable */
    NewMedicalCheckups = 'newMedicalCheckups',
    /** История медосмотров - MedicalCheckupsHistoryTable */
    MedicalCheckupsHistory = 'medicalCheckupsHistory',
    /** Медицинский журнал - MedicalJournalTable */
    MedicalJournal = 'medicalJournal',
}

